import { createSelector } from 'reselect';
import get from 'lodash/get';
import { Selector } from 'model/State';
import { cartCountryValidationSelector } from './getCartCurrencyValidation';

export default createSelector(cartCountryValidationSelector, (cartCurrencyValidation) => {
  const validationResult = cartCurrencyValidation.result;
  return get(validationResult, 'compatible', false) && get(validationResult, 'lockedCartCurrency');
}) as Selector<boolean>;
